import React, { Component, Fragment } from "react";
import Table from "../../../utilities/table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button } from "react-bootstrap";
import FormContainer from "../../../../containers/modules/sales/selling/form";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import { paymentType, transactionSelling } from "../../../utilities/Const/TranscationCode";
import LabelSelling from "../../../utilities/Status/selling";
import LabelPaymentType from "../../../utilities/Status/payment-type";
import TableSelling from "./table";
const MySwal = withReactContent(Swal);
export class Selling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      titleModal: "",
      listData: [],
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Sales"), class: " text-gray-600" },
        { link: null, title: i18n.t("Sales Invoice"), class: " text-gray-500" },
      ],
      column: [
        {
          key: "transaction_no",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Invoice No."),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "date_format",
          filter: { active: true, type: "DateBetween", data: null },
          title: i18n.t("Date"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "name_branch",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Branch Name"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "name_customer",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Customer Name"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "name_sales",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Sales Name"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
          
        },
        // {
        //   key: "id_do",
        //   filter: { active: true, type: "Text", data: null },
        //   title: i18n.t("Delivery No."),
        //   type: "text",
        //   tHclass: "text-center min-w-125px",
        //   tdClass: "",
        // },
        {
          key: "payment_type",
          filter: {
            active: true,
            type: 'Select',
            data: paymentType
          },
          title: i18n.t("Payment Type"),
          type: "component",
          tHclass: "min-w-125px",
          tdClass: "",
          component: (data, column) => {
            return <LabelPaymentType value={data[column.key]} />
          }
        },
        {
          key: "total_format",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Total Price"),
          tHclass: "min-w-150px",
          tdClass: "",
        },
        {
          key: "status",
          filter: {
            active: true,
            type: 'Select',
            data: transactionSelling
          },
          title: i18n.t("Status"),
          type: "component",
          tHclass: "min-w-125px",
          tdClass: "",
          component: (data, column) => {
            return <LabelSelling value={data[column.key]} />
          }
        },
        {
          key: "createdAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        // {
        //   key: 'id',
        //   filter: {
        //     active: false
        //   },
        //   title: i18n.t('Action'),
        //   type: 'action',
        //   tHclass: 'text-center min-w-150px',
        //   tdClass: '',
        //   buttons: [
        //     {
        //       key: "id",
        //       btnText: i18n.t("Void"),
        //       visible: {
        //         key: "status",
        //         params: [1, 2],
        //         function: (id, params) => {
        //           return params.includes(id);
        //         },
        //       },
        //       btnFunction: (data, column) => {
        //         this.cancelData(data);
        //       },
        //       bthClass: "btn btn-danger",
        //     },
        //     {
        //       key: 'id',
        //       btnText: i18n.t('Print'),
        //       visible: {
        //         key: 'status',
        //         params: [],
        //         function: (id, params) => {
        //           return true;
        //         },
        //       },
        //       btnLink: {
        //         url: "/sales/selling/print",
        //         target: "_blank",
        //       },
        //       bthClass: 'btn btn-warning',
        //     },

        //   ]
        // },
        {
          key: "id",
          filter: {
            active: false,
          },
          title: i18n.t("Action"),
          type: "action",
          tHclass: "text-center min-w-125px",
          tdClass: "text-center",
          form:"icon",
          buttons: [
            {
              key: "id",
              btnText: i18n.t("View"),
              visible: {
                key: "status",
                params: [],
                function: (id, params) => {
                  return true;
                },
              },
              btnFunction: (data, column) => {
                this.viewData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Void"),
              visible: {
                key: "status",
                params: [1,2],
                function: (id, params) => {
                 if(params.includes(id) == true){
                  const {authUser}=this.props
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Selling Delete')){
                      return true
                    }
                  }
                 }
                  return false;
                },
              },
              btnFunction: (data, column) => {
                this.cancelData(data);
              },
              bthClass: "btn btn-danger",
            },
            {
              key: "id",
              btnText: i18n.t("Print"),
              visible: {
                key: "status",
                params: [],
                function: (id, params) => {
                  const {authUser}=this.props
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Selling Print')){
                      return true
                    }
                  }
                  return false;
                },
              },
              btnFunction: (data, column) => {
                // this.cancelData(data);
              },
              bthClass: "btn btn-danger",
            },
          ],
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.cancelData = this.cancelData.bind(this);
    this.createData = this.createData.bind(this);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.titleModal = i18n.t("Add Sales Invoice");
    this.props.createData();
  }
  updateData(id) {
    this.state.titleModal = i18n.t("Edit Sales Invoice");
    this.props.updateItem(id);
  }

  cancelData(id) {
    const html = (
      <>
        <div>{i18n.t("Void This Data")}</div>
        <Button variant="secondary" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            MySwal.fire({
              title: i18n.t("Enter your message"),
              icon: false,
              input: "text",
              inputValue: "",
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                if (!value) {
                  return i18n.t("You need to write something!");
                }
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const value = result.value;
                MySwal.fire({
                  title: i18n.t("Proccessing Data"),
                  html: i18n.t("Please Wait ...."),
                  icon: "info",
                });
                MySwal.showLoading();
                this.props.cancelItem(id, value, this.state.search);
              }
            });
          }}
        >
          {i18n.t("Accept")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }
  renderCreateButton(){
    const {authUser}=this.props
    if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
      let route=authUser.userAccess.route
      if(route.includes('Selling Create')){
        return (<Button
          type="button"
          className="btn btn-primary m-1"
          onClick={(e) => this.createData()}
        >
          {i18n.t("Add Sales Invoice")}
        </Button>)
      }
    }
    return null;
  }
  render() {
    const { isProcessing, data, showModal } = this.props;
    this.state.listData = data;
    
    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <Button
                      type="button"
                      className="btn btn-warning m-1"
                      onClick={(e) => this.runSearch(this.state.search)}
                    >
                      <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                    </Button>
                    <Fragment>
                      {this.renderCreateButton()}
                    </Fragment>
                    {/* <Button
                      type="button"
                      className="btn btn-primary m-1"
                      onClick={(e) => this.createData()}
                    >
                      {i18n.t("Add Sales Invoice")}
                    </Button> */}
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <TableSelling
                  checkAble={false}
                  numberAble={true}
                  expandAble={true}
                  theExpand={{
                    key: "selling_detail",
                    columns: [
                      { label: i18n.t("Item Code"), key: "code_item" },
                      { label: i18n.t("Item Name"), key: "name_item" },
                      { label: i18n.t("Qty"), key: "qty_format" },
                      { label: i18n.t("Unit"), key: "name_unit" },
                      { label: i18n.t("Banderol"), key: "band_no" },
                      { label: i18n.t("Nett Price"), key: "nett_price_format" },
                      { label: i18n.t("Total Price"), key: "total_format" },
                    ],
                  }}
                  data={this.state.listData}
                  tools={false}
                  filterSearch={true}
                  column={this.state.column}
                  searchData={this.state.search}
                  runSearch={this.runSearch}
                  deleteData={this.deleteData}
                  updateData={this.updateData}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>
        <FormContainer
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
      </div>
    );
  }
}

export default Selling;
